const CONNECTOR_LOGIN_HOST = /^login\.(?:[a-z0-9-]+\.)*(?:finnecto\.com|localhost)$/

const CONNECTOR_LOGIN_PATHS = ['/connect', '/auth/login', '/auth/auth0-callback', '/auth/forgot_password']

export function isConnectorLoginHost(hostname: string = window.location.hostname): boolean {
  return CONNECTOR_LOGIN_HOST.test(hostname)
}

export function isConnectorLoginPath(path: string): boolean {
  return CONNECTOR_LOGIN_PATHS.some((allowed) => path === allowed || path.startsWith(`${allowed}/`))
}
